import { Observable } from 'rxjs';
import { CompanyAdminConfiguration } from '../../models/company-admin-configuration';

export abstract class ICompanyAdminConfigurationService {
  public abstract get(bkCompanyKey: string): Observable<CompanyAdminConfiguration>;
}
